module.exports = __webpack_public_path__ + "img/BA.c96fe7bf.svg";